<script setup lang="ts">
import {
  computed,
} from 'vue';

import type { IFormPlainDataListboxPropsChangeState } from '@modules/forms/types';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import VFormPlainDataListbox
  from '@modules/forms/components/inputs/VFormPlainDataListbox/VFormPlainDataListbox.vue';
import {
  TRANSLATION_GROUP_GENERAL_SETTINGS_REGISTRATION_FIELDS,
} from '@modules/general-settings/submodules/registration-fields/constants';
import {
  useSettingsRegistrationFieldsSaveMutation,
} from '@modules/general-settings/submodules/registration-fields/mutations';
import useSettingsRegistrationFieldsListQuery
  from '@modules/general-settings/submodules/registration-fields/queries/useSettingsRegistrationFieldsListQuery';

const { data, isLoading } = useSettingsRegistrationFieldsListQuery();
const { mutate, isPending } = useSettingsRegistrationFieldsSaveMutation();

const options = computed(() => data.value?.affiliate_checked ?? []);

function onChange({ check, values, ...required_fields }: IFormPlainDataListboxPropsChangeState<string>): void {
  mutate({
    actionType: check ? 'add' : 'remove',
    required_fields,
  });
}
</script>

<template>
  <VCard v-data-qa-auto-id="'AdminGeneralSettingsRegistrationFieldsPage'">
    <VLoader
      :loading="isLoading"
      min-height="350px"
    >
      <VFormPlainDataListbox
        :label="$getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS_REGISTRATION_FIELDS, 'LABEL')"
        :data="options"
        translation-path="auth.registration.form."
        :disabled="isPending"
        @change="onChange"
      />
    </VLoader>
  </VCard>
</template>
